import RequestAccountComponent from '../RequestAccountComponent.vue'
import AccountActionComponent from '../AccountActionComponent.vue'
import AccountAutologinComponent from '../AccountAutologinComponent.vue'

export default [
    {
        // Guest-facing "request an account" form. Guests are redirected here
        // when they hit a page that requires auth (e.g. floor plan).
        path: '/request-account',
        name: 'RequestAccount',
        meta: { layout: 'blank' },
        component: RequestAccountComponent,
    },
    {
        // One-click Approve / Decline landing page for the account-request
        // notification email. No auth — the ?expires/&signature query is a
        // capability token that this page forwards to the API.
        path: '/account-action/:id/:decision',
        name: 'AccountAction',
        meta: { layout: 'blank' },
        component: AccountActionComponent,
    },
    {
        // One-time autologin link sent in the approval email. :dest is a
        // frontend-only routing hint (e.g. "floor-plan") for where to land
        // after logging in — defaults to the dashboard.
        path: '/account-autologin/:id/:dest?',
        name: 'AccountAutologin',
        meta: { layout: 'blank' },
        component: AccountAutologinComponent,
    },
]
